export default __webpack_public_path__ + "static/media/calender.43003146.svg";